import { isPossiblePhoneNumber } from 'libphonenumber-js';

export function password(value: string) {
  if (value.length < 8) {
    return 'At least 8 characters required';
  }
  if (!/[a-z]/.test(value)) {
    return 'At least one lowercase letter required';
  }
  if (!/[A-Z]/.test(value)) {
    return 'At least one uppercase letter required';
  }
  if (!/[\d]/.test(value)) {
    return 'At least one number required';
  }
  return null;
}

export function sameAs(field: string, message: string) {
  return function (value: any, form: any) {
    if (!form[field]) return null;
    if (value !== form[field]) {
      return message;
    }
    return null;
  };
}

export function mustBeChecked(reason?: any) {
  return function (value: any) {
    if (!value) return reason || 'Required';
    return null;
  };
}

export function onlyLatinCharacters(value: string) {
  if (!value.match(/^[A-Za-z\s]+$/)) return 'Only latin characters allowed';
  return null;
}

export function phoneNumber(phone: string) {
  if (!phone) return null;
  if (!isPossiblePhoneNumber(phone)) return 'Invalid phone number format';
  return null;
}

export function mustBeWholeNumber(value: string) {
  if (!Number.isInteger(+value)) return 'Must be a whole number';
  return null;
}
